import { render, staticRenderFns } from "./TestInfo.vue?vue&type=template&id=6fd9c4c4&scoped=true"
import script from "./TestInfo.vue?vue&type=script&lang=js"
export * from "./TestInfo.vue?vue&type=script&lang=js"
import style0 from "./TestInfo.vue?vue&type=style&index=0&id=6fd9c4c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd9c4c4",
  null
  
)

export default component.exports